<template>
    <el-form label-width="150px" class="drawableForm"
    >
        <el-form-item label="抽籤登記排序">
            <el-button
                    @click="show = true"
                    type="primary"
            >顯示
            </el-button>
        </el-form-item>
        <el-form-item label="活動名稱摘要">
            <el-input
                    type="textarea"
                    :value="form.activity"
                    resize="none"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="參加人數">
            <el-input
                    :value="form.numberOfParticipants"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="參加對象">
            <el-input
                    :value="form.participants"
                    type="textarea"
                    resize="none"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="連絡電話">
            <el-input
                    :value="form.contact"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="郵件信箱">
            <el-input
                    :value="form.email"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="單位主管或指導老師">
            <el-input
                    :value="form.advisor"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="器材數量">
            <el-input
                    :value="form.equipments"
                    type="textarea"
                    resize="none"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="檢附文件">
            <small>※活動企劃書(練習及社團時間免附計畫書)或簽核文件</small>
            <div style="margin: 0;padding: 0">
                <a
                        style="margin: 0;padding: 0"
                        href="#"
                        v-for="download in form.downloads"
                        :key="download.key"
                        type="info"
                        @click.prevent="click(download)"
                >
                    {{download.fullName}}
                </a>
            </div>
        </el-form-item>
        <el-dialog
                title="登記的抽籤排序"
                :visible.sync="show"
                append-to-body
        >
            <el-table
                    :data="priorities"
            >
                <el-table-column
                        prop="date"
                        label="日期"
                ></el-table-column>
                <el-table-column
                        prop="priorities"
                        label="登記順序"
                        width="700px"
                ></el-table-column>
            </el-table>
            <template #footer>
                <el-button @click="show = false">
                    關閉
                </el-button>
            </template>
        </el-dialog>
    </el-form>
</template>

<script>
    import {mapActions} from 'vuex';
    import moment from 'moment';

    const defaultForm = {
        activity: '',
        numberOfParticipants: 1,
        participants: '',
        equipments: '',
        advisor: '',
        range: [],
        contact: '',
        details: [],
        email:''
    };

    export default {
        name: 'DrawableForm',
        props: {
            form: {
                type: Object,
                default: () => ({...defaultForm}),
                required: true
            }
        },
        data: () => ({
            show: false
        }),
        computed: {
            priorities() {
                const grpByDate = (this.form.priorityPeriods || []).reduce((grpByD, d) => {
                    (grpByD[d.date] = (grpByD[d.date] || [])).push(d);
                    return grpByD;
                },{});
                return Object
                    .keys(grpByDate)
                    .sort()
                    .reduce((lst, k) => {
                        return [...lst, {
                            date : k,
                            priorities: [...grpByDate[k]].sort((a, b) => a.order - b.order)
                                .map(({order, roomName, tag, timeBegin, timeEnd}) =>
                                    `[${order}]${roomName}-${tag}`)
                                .join('、')
                        }]
                    }, [])
             ;
            }
        },
        methods: {
            ...mapActions({
                download: 'downloadFileAction'
            }),
            async click(download) {
                await this.download(download);
            }
        },
        filters: {
            shortDate(date) {
                if (date) {
                    return moment(date).format('YYYY-MM-DD');
                }
                return '';
            }
        }
    }
</script>

<style>
    .drawableForm .el-alert {
        cursor: pointer;
    }
</style>